/* global Splide */
"use strict";

($dt => {

	$dt.blocks.masthead = {

		/**
		 * This is called for each block matching this type
		 * @param {HTMLElement} container 
		 */
		LoadBlock: container => {

			const slider = container.querySelector('.splide');

			if (slider) {
				const options = {
					type: 'fade',
					autoplay: true,
					interval: 8000,
					pauseOnHover: true,
					pauseOnFocus: true,
					rewind: true,
					perPage: 1
				};

				const splide = new Splide(slider, options);

				// console.log(splide);

				// var items = splide.length; 
				// var perPage = splide.options.perPage;
				// console.log(items);
				// // var perPage = splide.options.perPage; //The perPage value

				// if (items <= perPage) { //If amount of items is equal or less than perPage value
				// 	splide.options.pagination = false; 
				// }

				// console.log(items);
				// console.log(perPage);

				// console.log(options);

				splide.mount();
			}
		}

	};

})(window.d3_wp_themejs);
